/**
 * map of content.contenType as key and the import path (from ~/components/solepro/) of the  component to render as value
 */
export const ALLOWED_COMPONENTS = {
  row: () => import('~/components/solepro/PageBuilder/Row.vue'),
  'column-group': () => import('~/components/solepro/PageBuilder/ColumnGroup.vue'),
  'column-line': () => import('~/components/solepro/PageBuilder/ColumnLine.vue'),
  'column': () => import('~/components/solepro/PageBuilder/Column.vue'),
  tabs: () => import('~/components/solepro/PageBuilder/Tabber.vue'),
  'tab-item': true, // mapping just to make an object to use inside Tabber
  'video': () => import('~/components/solepro/PageBuilder/Video.vue'),
  'banner': () => import('~/components/solepro/PageBuilder/Banner.vue'),
  'slider': () => import('~/components/solepro/PageBuilder/Slider.vue'),
  // 'slide': () => import('~/components/solepro/PageBuilder/Slide.vue'),
  'evidences': () => import('~/components/solepro/PageBuilder/Evidences.vue'),
  'tutorial': () => import('~/components/solepro/PageBuilder/Tutorial.vue'),
  // 'evidence': () => import('~/components/solepro/PageBuilder/Evidence.vue'),
  'products': () => import('~/components/solepro/PageBuilder/Products.vue'),
  'block': () => import('~/components/solepro/PageBuilder/Block.vue'),
  'image': () => import('~/components/solepro/PageBuilder/Image.vue'),
  'buttons': () => import('~/components/solepro/PageBuilder/Buttons.vue'),
  'accordion': () => import('~/components/solepro/PageBuilder/Accordion.vue'),
  'plp-product-box': () => import('~/components/solepro/PageBuilder/PLPProductBoxWrapper.vue'),
  'punti-forza-grid': () => import('~/components/solepro/PageBuilder/PuntiForzaGrid.vue'),
  'logos-carousel': () => import('~/components/solepro/PageBuilder/LogosCarousel.vue'),
  'pacchetti-marketing': () => import('~/components/solepro/PageBuilder/MarketingCards/MarketingCards.vue'),
  'marketing-1-prodotto': () => import('~/components/solepro/PageBuilder/MarketingProduct/MarketingProduct.vue'),
  'text-carousel': () => import('~/components/solepro/PageBuilder/TextCarousel.vue'),
  'plans-benchmark': () => import('~/components/solepro/PageBuilder/EditorialBenchmark.vue'),
  'home-eventi': () => import('~/components/solepro/PageBuilder/Events.vue'),
  'tabber-faqs': () => import('~/components/solepro/PageBuilder/TabberFaqs.vue'),
  'image-box-slider': () => import('~/components/solepro/PageBuilder/ImageBoxSlider.vue'),
  'snapshot-line': () => import('~/components/solepro/PageBuilder/SnapshotLine.vue'),
};


// 2. Creiamo una mappa di configurazione per le classi speciali
const CLASS_TO_COMPONENT_MAP = {
  'section-tutorials': 'tutorial',
  'plp-product-box': 'plp-product-box',
  'punti-forza-grid': 'punti-forza-grid',
  'logos-carousel': 'logos-carousel',
  'partnerships-carousel': 'logos-carousel', // Gestisce il caso OR che avevi
  'pacchetti-marketing': 'pacchetti-marketing',
  'marketing-1-prodotto': 'marketing-1-prodotto',
  'text-carousel': 'text-carousel',
  'plans-benchmark': 'plans-benchmark',
  'home-eventi': 'home-eventi',
  'tabber-faqs': 'tabber-faqs',
  'image-box-slider':'image-box-slider',
  "snapshot-line":"snapshot-line"
};

// 3. Funzione ottimizzata
export const getComponent = (componentName, cssClasses = []) => {
  // Cerchiamo nella mappa se una delle classi passate esiste tra le chiavi
  const foundKey = cssClasses.find(className => CLASS_TO_COMPONENT_MAP[className]);

  if (foundKey) {
    const componentKey = CLASS_TO_COMPONENT_MAP[foundKey];
    return ALLOWED_COMPONENTS[componentKey];
  }

  // Comportamento di default
  const component = ALLOWED_COMPONENTS[componentName];
  return (component && typeof component !== 'boolean') ? component : 'div';
};